import { render } from "./post-list.vue?vue&type=template&id=209b8a03"
import script from "./post-list.vue?vue&type=script&lang=js"
export * from "./post-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__